import { __ } from '@wordpress/i18n';

/**
 * Immersive block state management
 */
const immersiveSectionVideoStateManagement = () => {
	const immersiveBlockVideos = document.querySelectorAll( '.wp-block-msr-immersive-section.has-video' );
	const mediaQuery = window.matchMedia( '(prefers-reduced-motion: reduce)' );
	const playText = __( 'Play video', 'ms-research' );
	const pauseText = __( 'Pause video', 'ms-research' );
	
	/**
	 * Pause the video
	 * 
	 * @param {object} video 
	 * @param {object} videoIcon 
	 */
	const pauseVideo = ( video, videoIcon ) => {
		video.pause();
		videoIcon.classList.remove( 'dashicons-controls-pause' );
		videoIcon.classList.add( 'dashicons-controls-play' );
		videoIcon.nextElementSibling.textContent = playText;
	};

	/**
	 * Play the video
	 * 
	 * @param {object} video 
	 * @param {object} videoIcon 
	 */
	const playVideo = ( video, videoIcon ) => {
		video.play();
		videoIcon.classList.remove( 'dashicons-controls-play' );
		videoIcon.classList.add( 'dashicons-controls-pause' );
		videoIcon.nextElementSibling.textContent = pauseText;
	};

	if ( immersiveBlockVideos.length ) {
		[...immersiveBlockVideos].forEach( videoBlock => {
			const videoButton = videoBlock.querySelector( '.wp-block-msr-immersive-video__button' );
			const videoIcon = videoButton.querySelector( '.dashicons' );
			const video = videoButton.previousElementSibling;

			if ( !mediaQuery || mediaQuery.matches ) {
				video.autoplay = false;
				pauseVideo( video, videoButton );
			}

			/**
			 * Play pause button event
			 */
			videoButton.addEventListener( 'click', () => {
				if ( !video.paused ) {
					pauseVideo( video, videoIcon );
				} else {
					playVideo( video, videoIcon );
				}
			} );

			mediaQuery.addEventListener( 'change', () => {
				if ( mediaQuery.matches ) {
					pauseVideo( video, videoIcon );
				} else {
					playVideo( video, videoIcon );
				}
			} );
		} );
	}
};

/**
 * Init video search function
 */
const init = () => {
	// Return all the youtube and vimeo embeds on a page
	const videoEmbeds = document.querySelectorAll( 'iframe[src*="youtube"], iframe[src*="vimeo"]' );
	const videoEmbedsCount = videoEmbeds.length;
	let videoSrc;

	if ( videoEmbedsCount ) {

		// Loop through the videos to add the appropriate title attribute
		// array destructure for ie11
		[...videoEmbeds].forEach( videoEmbed => {
			videoSrc = videoEmbed.getAttribute( 'src' );

			if ( -1 !== videoSrc.indexOf( 'youtube' ) ) {

				videoEmbed.setAttribute( 'title', 'YouTube Video Player' );
			} else if ( -1 !== videoSrc.indexOf( 'vimeo' ) ) {

				videoEmbed.setAttribute( 'title', 'Vimeo Video Player' );
			}

		} );

	} // if

	// Run immersive block 
	immersiveSectionVideoStateManagement();
}; // init()

// Exports
export default init;
